import moment from "moment-timezone";
import dayjsTZ from "../../../../utils/dayjs";
import { getTranslation } from "../../generate/translations";

export const requests = (data, filter, columns, manualColumns) => {
  let result = {
    columnsDef: [],
    allColumns: [],
    rowData: [],
    selectedColumns: [],
    allColumns: [],
  };
  if (!!data && !!filter) {
    result.selectedColumns = manualColumns || columns.columnDefs;
    result.allColumns = columns.allAppliedColumnDefs;

    // result.columnsDef.push("Emer", "Mbiemer", "Lloji", "Fillim", "Mbarim", "Departamenti");
    const preFilter = data
      .filter((f) => {
        let times = f?.requestPeriod || [];
        const filterByEmployee = filter.employeeId
          ? f?.employeeDetails?.employeeId === filter.employeeId
          : true;
        return filterByEmployee && times.some(
          (el) =>
            dayjsTZ(el).isSameOrAfter(filter?.timeInterval[0]) &&
            dayjsTZ(el).isSameOrBefore(filter?.timeInterval[1])
        );
      })
      .map((d) => ({
        ...d,
        ...d?.employeeDetails,
        requestStart: dayjsTZ(d?.requestPeriod[0]).format("DD/MM/YYYY"),
        requestEnd:
          d?.requestPeriod.length > 1
            ? dayjsTZ(d?.requestPeriod[d?.requestPeriod?.length - 1]).format(
                "DD/MM/YYYY"
              )
            : dayjsTZ(d?.requestPeriod[0]).format("DD/MM/YYYY"),
      }));

    if (!!manualColumns && Array.isArray(manualColumns)) {
      manualColumns.forEach((e) => {
        result.columnsDef.push(getTranslation(e));
      });
      preFilter.forEach((emplRecord) => {
        let toAdd = [];
        manualColumns.forEach((c) => toAdd.push(emplRecord[c]));
        result.rowData.push(toAdd);
      });
    } else {
      columns?.columnDefs.forEach((e) => {
        result.columnsDef.push(getTranslation(e));
      });
      preFilter.forEach((emplRecord) => {
        console.log("preFilter", preFilter);
        let toAdd = [];
        columns?.columnDefs?.forEach((c) => toAdd.push(emplRecord[c]));
        result.rowData.push(toAdd);
      });
    }

    return result;
  }
  return result;
};
